<section class="about-area" style="background-color: #fafafa;">
    <div class="container pt-100">

            <h2>Our Initiatives</h2>
            <div class="bar"></div>

  <p>
   As part of our mission, we strive empowering businesses and people through training, skills development and technology. DotBlack has developed a scalable white
   labeled web based solution <strong>Home Incident Management (HIM)</strong> which is our minimal viable product as part of our pilot phase. The Home and Incident Management tool
   that focus on managing claims from various short-term insurance companies which require a solution-based approach and efficient responses. The system primarily
   manages incidents from start to completion including managing suppliers and client relationships throughout the process.
  </p><br>

  <p>
   In order to respond successfully and complete the claims/incidents, we will set up an incubation centre that will offer skills development and training that is directly linked
   to the property, insurance and incident management industries while creating sustainable avenues for employment for Black owned small businesses.
  </p><br>

  <p>
    In light of the critical role that SMME’s play in economic development, <strong>Davha</strong> was established as an incubation hub for entrepreneurs within the Insurance Industry &
    Property Development sector. The objective of the incubator is to provide development and support for potential Black owned small businesses from previously
    disadvantaged backgrounds.
  </p><br>

  <p>
    We have formed a partnership with Davha a company specialising in providing the highest quality artisan skills development with continuous training and
    education within the artisan training facility sphere. A high priority is put into ensuring that the relevant accreditation’s are met and maintained. The courses have been
    designed to provide the student with the industry relevant certifications, recognized by industry for maximum employability
  </p><br>

 <h4>Our Training Institute is Registered With:</h4>
<div class="row align-items-center">
  <!-- List -->
  <div class="col-lg-6 col-md-12">
    <ul>
      <li>Construction Education and Training Authority (CETA)</li>
      <li>Manufacture, Engineering and Related Services SETA (MERSETA)</li>
      <li>Energy and Water Sector Education and Training Authority (EWSETA)</li>
      <li><strong>Institution of Plumbing South Africa (IOPSA)</strong></li>
      <li><strong>Plumbing Industry Registration Board (PIRB)</strong></li>
      <li><strong>Registered Solar Geyser Training Facility</strong></li>
    </ul>
  </div>

  <!-- Image -->
  <div class="col-lg-6 col-md-12 text-center">
    <img src="assets/img/davha-incubation.png" alt="Davha Incubation" class="img-fluid rounded shadow-sm"
         style="max-width: 100%; height: auto;">
  </div>
</div>

<br>
  <p>
    Once the service provider has completed the training and has been certified,
    their business will be registered into the HIM system and will become eligible
    to receive jobs/incidents that have been logged.
  </p><br>

  <p>
    As part of the next phase, we will extend the current web-based solution
    and also develop a mobile application. This app will be made available to both the service provider
    and the homeowner,enabling incident tracking from the time it's logged to its completion.
  </p><br>
  <br>


    </div>
       <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image"></div>
    </div>
</section>
